<!--
 * @Author: yaoyuting
 * @Date: 2020-03-20 19:30:58
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-01 09:21:06
 * @Descripttion:
-->
<template>
  <div class="appcontent">
    <div class="footer" id="footer" ref="footer">
      <div class="footer_c">
        <!-- <div class="footer_tit">Contact Us</div> -->
        <div class="footer_con">
          <div class="footer_cs">
            <div class="footer_csl">
              <div class="footer_cti">Contact Us</div>
              <!-- <img class="imga" src="../../assets/m/indexpic/ios.png" />
              <img class="imgb" src="../../assets/m/indexpic/adr.png" /> -->
              <a
                data-testid="linkElement"
                href="mailto:contact@uqc.world"
                target="__black"
              >
                <img class="imga" src="@/assets/m/indexpic/footer1.png" />
              </a>
              <a href="https://twitter.com/UQC_VC" target="__black">
                <img class="imgb" src="@/assets/m/indexpic/footer2.png" />
              </a>
            </div>
            <!-- <div class="footer_csl">
              <div class="footer_ctia">Raindrop Digital</div>
             
              <a
                data-testid="linkElement"
                href="#"
                target="__black"
              >
                <img class="imgc" src="@/assets/m/indexpic/ios.png" />
              </a>
              <a href="http://www.uqc.world/apk/Tick-Wallet.apk" target="__black">
                <img class="imgd" src="@/assets/m/indexpic/adr.png" />
              </a>
            </div> -->
          </div>
          <!-- <div class="footer_cx"></div> -->
          <!-- <div class="footer_conl">
            <a
              data-testid="linkElement"
              href="mailto:contact@uqc.world"
              target="__black"
            >
              <img class="imga" src="@/assets/m/indexpic/footer1.png" />
            </a>
            <a href="https://twitter.com/UQC_VC" target="__black">
              <img class="imgb" src="@/assets/m/indexpic/footer2.png" />
            </a>
          </div>
          <div class="footer_conr">
            <a href="#"> Tick Wallet download </a>
            <a href="#"> Tick Wallet download </a>
          </div> -->
        </div>
        <div class="footer_btm">
          <div class="footer_line"></div>
          <div class="footer_uqc">Copyright © UQC</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetEmail } from "@/assets/server/api";
export default {
  data() {
    return {
      timer: null, // 定时器名称
      ruleForm: { email: "" },
      rules: {
        email: [
          {
            required: true,
            type: "email",
            // message: "Please input email",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    // this.$bus.$emit("#footer");
  },
  methods: {
    async submitForm(formName) {
      var regEmail =
        /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (formName != "") {
        if (formName != "" && !regEmail.test(formName)) {
          this.$message({
            message: "Email must be formatted correctly",
            type: "error",
          });
          this.ruleForm.email = "";
        } else {
          let formData = new FormData();
          let params = {
            email: this.ruleForm.email,
          };
          console.log("params", params);
          let item = params;
          for (const key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
              formData.append(key, item[key]);
            }
          }
          let data = await GetEmail(formData);
          this.$message({
            showClose: true,
            message: "Mailbox subscription succeeded",
            type: "success",
          });
          this.ruleForm.email = "";
        }
      } else {
        this.$message({
          message: "Please enter your e-mail address",
          type: "error",
        });
      }
    },
    goPage(url) {
      this.$router.push(url);
      this.show = false;
      this.shows1 = false;
      this.currentPath = url;
      sessionStorage.setItem("currentPath", url);
    },
    buildPage() {
      this.$message({
        message: "Coming Soon",
        type: "warning",
      });
    },
    jump(id) {
      var aa = document.querySelector(id);
      // console.log(id);
      this.timer = setTimeout(function () {
        document.querySelector(id).scrollIntoView(true);
      }, 100);

      this.$once("hook:beforeDestroy", () => {
        clearInterval(timer);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.appcontent {
  width: 750px;
  // margin: 120px auto 0px auto;
  background: #f6f7fb;
  text-align: center;
  .footer {
    width: 750px;
    height: 228px;
    border: none !important;
    // border: 1px solid red;
    background: #2f47ee;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    .footer_c {
      width: 694px;
      margin: 0 auto;
      margin-top: 20px;
     //  border: 1px solid red;
     
      .footer_con {
        display: flex;
        justify-content: space-between;
        // border: 1px solid red;
        margin-top: 42px;
        .footer_cs {
          .footer_csl {
            display: flex;
            margin-top: 21px;
            margin-left: 180px;
            .footer_cti {
              font-size: 24px;
              font-family: Roboto-Regular, Roboto;
              font-weight: 400;
              color: #ffffff;
            }
            .footer_ctia{
              margin-top: 8px;
               font-size: 24px;
              font-family: Roboto-Regular, Roboto;
              font-weight: 400;
              color: #fff;
            }
            .imga {
              width: 48px;
              height: 34px;
              margin-left: 65px;
            }
            .imgb {
              width: 48px;
              margin-left: 65px;
              height: 41px;
            }
            .imgc {
              width: 37px;
              height: 46px;
              margin-left: 72px;
            }
            .imgd {
              width: 37px;
              margin-left: 78px;
              height: 41px;
              margin-top: 6px;
            }
          }
        }
        .footer_cx {
        }
        // .footer_conl {
        //   .imga {
        //     width: 48px;
        //     height: 34px;
        //     margin-right: 60px;
        //   }
        //   .imgb {
        //     width: 48px;
        //     height: 41px;
        //   }
        // }
        // .footer_conr {
        //   font-size: 12px;
        // }
      }
      .footer_btm {
        margin-top: 24px;
        display: flex;
        justify-content: space-between;
        .footer_line {
          width: 270px;
          height: 10px;
          background: #ffffff;
          border-radius: 200px 200px 200px 200px;
          opacity: 1;
          margin-left: 200px;
          margin-top: 10px;
        }
        .footer_uqc {
          height: 28px;
          font-size: 24px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #ffffff;
          line-height: 0px;
        }
      }
    }
  }
}
</style>
